import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Divider} from '@/components/ui/divider/Divider'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {WarningLabel} from '@/components/ui/warning-label/WarningLabel'

interface ClinicalPresentationsCardEmptyStateProps {
    isLoading: boolean
}
export const ClinicalPresentationsCardEmptyState = ({isLoading}: ClinicalPresentationsCardEmptyStateProps) => {
    const {t} = useTranslation()

    return (
        <Grid columns={3} gap={3} fullWidth>
            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:cognitive_disorders')}
                    </Text>
                    {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:behavioral_disorders')}
                    </Text>
                    {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <Flexbox direction="column" gap={2} fullWidth justify="space-between">
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:communication_disorders')}
                    </Text>
                    {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
                </DetailsField>
                <Divider direction="horizontal" />
            </Flexbox>

            <DetailsField fullWidth>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:sensory_deficits')}
                </Text>
                {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
            </DetailsField>

            <DetailsField fullWidth>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:clinical_stability_level')}
                </Text>
                {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
            </DetailsField>

            <DetailsField fullWidth>
                <Text palette="neutral" shade="500" size="textSm">
                    {t('projects:care_needs')}
                </Text>
                {isLoading ? <Skeleton height={24} /> : <WarningLabel text={t('users:to_compile')} />}
            </DetailsField>
        </Grid>
    )
}
